import { AxiosResponse } from 'axios';

import { http } from '@/api/http';
import { IGetParams, IPaginatedListResponse } from '@/api/types';
import { ApiVersion } from '@/config';

export type DataWorksStatus =
  | 'CREATED'
  | 'IN_TEMP'
  | 'READY_FOR_BOOKING'
  | 'PROCESSED';

export interface IArrestToolRow {
  _id: string;
  arrestId?: string | null;
  fullName: string;
  arrestDate?: Date | null;
  arrestingOfficer?: {
    _id: string;
    firstName: string;
    lastName: string;
    fullName: string;
  } | null;
  arrestType?: string | null;
  arrestStatus?: string | null;
  wasArrested: number;
  kase: { _id: string; number: string };
  masterName: string;
  dataWorksStatus?: DataWorksStatus | null;
}

export const ArrestsToolApi = {
  list: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IArrestToolRow>>> => {
    return http.get(`api/${ApiVersion.V1}/arrests`, {
      params,
    });
  },
};
